export * as Inventory from './dashboard-page-plugins/59a8855e-515a-49c1-894a-035731d2fd44.js';
export * as Products from './dashboard-page-plugins/c821a776-85a9-4340-ae94-e08876c99944.js';
